import { render, staticRenderFns } from "./OpeningHoursRow.vue?vue&type=template&id=7dadc026"
import script from "./OpeningHoursRow.vue?vue&type=script&lang=js"
export * from "./OpeningHoursRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports